import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectInvoice } from '../selectors';
import { FormField, FormFields } from '../../../components/FormFields';
import { Input } from '../../../components/Form';
import { VBox } from '../../../components/Box';
import { AppClientId } from '../../Shared/constants';
import env from '../../../env';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const STATE = {
  protectMessage: '',
};

/* eslint-disable react/prefer-stateless-function */
class CreditInvoiceModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }

  applySelection() {
    this.props.addInvoiceRelation(this.state.selectedInvoice.id, this.reset.bind(this));
  }

  get modalMsg() {
    return <p>{this.lbl(`invoice.details.creditTip`)}</p>;
  }

  get modalProtectMsg() {
    if (env.clientId === AppClientId.AUTOWIENTJES) {
      return null;
    } else {
      return (
        <span>
          <p>{this.lbl('invoice.details.declineProtectMsg')}</p>{' '}
          <p style={{ fontWeight: 'bold' }}>{this.correctProtectMessage}</p>
        </span>
      );
    }
  }

  get correctProtectMessage() {
    if (env.clientId === AppClientId.AUTOWIENTJES) {
      return null;
    } else {
      return `Create credit invoice for invoice number ${this.props.invoice.entryNumber}`;
    }
  }

  get disableApplyBtn() {
    if (env.clientId === AppClientId.AUTOWIENTJES) {
      return false;
    } else {
      return !(this.correctProtectMessage === this.state.protectMessage);
    }
  }

  onConfirm() {
    this.props.onConfirm();
  }

  onCancel() {
    this.props.onCancel();
  }

  render() {
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl(`invoice.details.creditModalTitle`)}>
        {this.modalMsg}
        {env.clientId === AppClientId.AUTOWIENTJES ? (
          ''
        ) : (
          <FormFields>
            <VBox>
              <p>{this.modalProtectMsg}</p>
              <FormField>
                <input
                  className="form-control"
                  value={this.state.protectMessage}
                  name="protectMessage"
                  onChange={this.onInputChange.bind(this)}
                />
              </FormField>
            </VBox>
          </FormFields>
        )}
        <div className="d-flex gap-2">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            onClick={this.onConfirm.bind(this)}
            primary
            disabled={this.disableApplyBtn}
          >
            {this.lbl('confirm')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.onCancel.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

CreditInvoiceModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CreditInvoiceModal = compose(withConnect, withRouter)(CreditInvoiceModalComp);
